import type { ReactNode } from 'react';
import { useApolloClient } from '@apollo/client/react';
import { RoleGate } from '@/features/auth';
import { Role } from '@/entities/user/model/user.types';
import { useJob } from '@/entities/job';
import { SIGNALS_TABS, SignalsDenied } from '@/features/signals';
import { Button } from '@/shared/ui/button';
import { PageHeader } from '@/shared/ui/page-header';
import { RouteTabs } from '@/shared/ui/route-tabs';

function SignalsHeader() {
  const apollo = useApolloClient();
  const rederive = useJob('OPPORTUNITY_REDERIVE', {
    succeeded: 'Signals rebuilt.',
    failed: "Couldn't rebuild the signals.",
    onSucceeded: () =>
      void apollo.refetchQueries({ include: ['OpportunityCategorySummary', 'AdminSignals'] }),
  });

  return (
    <PageHeader
      title="Signals"
      description="Signals derived from crawl history. Each kind stays up for its own window, most for three months, and vendors are notified while a signal is new. Vendors only see categories switched on under Categories."
      actions={
        <Button
          variant="outline"
          size="sm"
          disabled={rederive.isRunning}
          onClick={() => void rederive.start()}
        >
          {rederive.isRunning ? 'Rebuilding…' : 'Re-derive'}
        </Button>
      }
    />
  );
}

export default function SignalsLayout({ children }: { children: ReactNode }) {
  return (
    <RoleGate roles={[Role.SUPER_ADMIN]} fallback={<SignalsDenied />}>
      <div className="space-y-6">
        <SignalsHeader />
        <RouteTabs tabs={SIGNALS_TABS} label="Signals sections" />
        {children}
      </div>
    </RoleGate>
  );
}
